import React from 'react';
import { Link } from 'react-router-dom';
import MeusPagamentosTable from '../common/tables/meus-pagamentos-table';

const MeusPagamentosArea = () => {
  return (
    <>
      <section className="blog__area pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12">
              <div className="blog__wrapper">
                <div className="blog__text mb-40">
                 
                <h2 className="section__title">Meus pagamentos</h2>

                  {/* table pagamento */}
                  
                  <MeusPagamentosTable />

                  {/* table pagamento */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MeusPagamentosArea;